import Actions from 'flow/actions';

// Dispatched by useInMeetingExternalMessages while it's rendering guest-relay messages (VID-433).
export const setVideoChatExternalMessagesViewingAction = (
    viewing: boolean,
) => ({
    type: Actions.VIDEO_CHAT_EXTERNAL_MESSAGES_VIEWING,
    viewing,
});
